import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-617.000000, -3291.000000)" fill={color}>
                <g id="Group-6-Copy-3" transform="translate(574.000000, 3248.000000)">
                    <path d="M59.2,59.2 L59.2,53.7917156 C59.2,52.8021784 59.9989567,52 61,52 C61.9941125,52 62.8,52.8083911 62.8,53.7917156 L62.8,59.2 L68.2082844,59.2 C69.1978216,59.2 70,59.9989567 70,61 C70,61.9941125 69.1916089,62.8 68.2082844,62.8 L62.8,62.8 L62.8,68.2082844 C62.8,69.1978216 62.0010433,70 61,70 C60.0058875,70 59.2,69.1916089 59.2,68.2082844 L59.2,62.8 L53.7917156,62.8 C52.8021784,62.8 52,62.0010433 52,61 C52,60.0058875 52.8083911,59.2 53.7917156,59.2 L59.2,59.2 Z M61,79 C51.0588745,79 43,70.9411255 43,61 C43,51.0588745 51.0588745,43 61,43 C70.9411255,43 79,51.0588745 79,61 C79,70.9411255 70.9411255,79 61,79 Z M61,75.4 C68.9529004,75.4 75.4,68.9529004 75.4,61 C75.4,53.0470996 68.9529004,46.6 61,46.6 C53.0470996,46.6 46.6,53.0470996 46.6,61 C46.6,68.9529004 53.0470996,75.4 61,75.4 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconPlusCircled extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
